import { InstructionFormDetails } from '../../commonAfterFormPage/InstructionFormDetails';
import config from '@app/config';
import { NiumFormDetails } from './NiumFormDetails';
import { hsbcPaymentInstructionsAddress, hsbcPaymentInstructionsLines } from './hsbcAccountDetails';

export const NiumHSBCAfterForm: InstructionFormDetails = {
  ...NiumFormDetails,
  paymentInstructionsLines: hsbcPaymentInstructionsLines,
  paymentInstructionsAddress: hsbcPaymentInstructionsAddress,
  downloadLink: `${config.supplierValidationAttachmentsUrl}NiumHSBC/en/nium-hsbc.pdf`,
};
